module.exports = __webpack_public_path__ + "static/media/m10.77a3f954.png";